document.addEventListener("DOMContentLoaded", () => {
  function updateLayoutPositioning() {
    const heroSectionContainer = document.getElementById('hero-new');
    const header = document.querySelector('.header__wrap');
    const fixedTextTop = document.getElementById('fixedTextTop');
    const fixedTextBottom = document.getElementById('fixedTextBottom');
    const topSection = document.getElementById('topSection');
    const heroImageContainer = document.querySelector('.hero-image-container');
    const isMobile = window.innerWidth <= 768;

    if (!fixedTextTop || !fixedTextBottom || !topSection || !heroImageContainer) return;

    const headerHeight = header.offsetHeight;
    heroSectionContainer.style.marginTop = `${headerHeight}px`;

    const topSectionHeight = topSection.offsetHeight;
    const textBottomHeight = fixedTextBottom.offsetHeight;
    const padding = 40;
    const heroImage = heroImageContainer.querySelector('.hero-image');
    const heroImageHeight = heroImage ? heroImage.offsetHeight : 0;

    // heroImageContainer.style.top = `${topSectionHeight + padding}px`;
    // heroImageContainer.style.transform = 'translateX(-50%)';
    // heroImageContainer.classList.remove('-translate-y-1/2');

    let textTopTargetY, textBottomTargetY;

    if (isMobile) {
      textTopTargetY = topSectionHeight  + (textBottomHeight * 0.4);
      textBottomTargetY = topSectionHeight + heroImageHeight  - (textBottomHeight * 0.3);
    } else {
      textTopTargetY = topSectionHeight + padding;
      textBottomTargetY = topSectionHeight + heroImageHeight + padding - (textBottomHeight * 0.6);
    }

    fixedTextTop.style.top = `${textTopTargetY}px`;
    fixedTextBottom.style.top = `${textBottomTargetY}px`;
  }

  updateLayoutPositioning(); 

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateLayoutPositioning, 150);
  });
  window.addEventListener('load', updateLayoutPositioning);

  const swiperContainer = document.querySelector(".hero-carousel");
  const autoplayDuration = swiperContainer.dataset.autoplayDuration || 5000; // Default to 5 seconds if not set


  // Initialize Swiper
  const swiper = new Swiper(".hero-carousel", {
    loop: true,
    speed: 1000,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1.4,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1.3,
        spaceBetween: -40,
      },
      1024: {
        slidesPerView: 1.4,
        spaceBetween: -40,
      },
      1400: {
        slidesPerView: 1.4,
        spaceBetween: -60,
      },
      1500: {
        slidesPerView: 1.4,
        spaceBetween: -80,
      },
    },
    autoplay: {
      delay: autoplayDuration,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    on: {
      init: function() {
        handleVideoPlayback(this);
      },
      slideChange: function() {
        handleVideoPlayback(this);
      },
      // Store current video position when navigating away
      slideChangeTransitionStart: function() {
        const activeSlide = this.slides[this.activeIndex];
        if (activeSlide) {
          const video = activeSlide.querySelector('video');
          if (video) {
            // Store current playback position on the video element as a data attribute
            video.dataset.lastPosition = video.currentTime;
          }
        }
      }
    }
  });
  
  // Simplified function to handle video playback
  function handleVideoPlayback(swiperInstance) {
    const slides = swiperInstance.slides;
    const activeIndex = swiperInstance.activeIndex;
    
    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;
      
      if (index === activeIndex) {
        // Active slide - play video from current position (don't reset)
        video.style.opacity = '1';
        
        // Play and setup ended event
        video.play().catch(() => {
          // If autoplay fails, rely on the 5-second autoplay
        });
        
        // When video ends, advance to next slide
        video.onended = () => swiper.slideNext();
      } else {
        // Non-active slides - pause and dim
        video.pause();
        // video.style.opacity = '0.7';
        video.onended = null;
      }
    });
  }

  const tl = gsap.timeline({
    defaults: {
      duration: 0.8,
      ease:CustomEase.create("customFadeIn", "M0,0 C0,0 0.58,1 1,1"),
    },
});


tl.to(".hero-title", { opacity: 1, y: 0 })
  .to(".hero-tags", { opacity: 1, y: 0 }, "<") // Shows up together with hero-title
  .to(".hero-image", { opacity: 1, y: 0}, "<+=0.3")
  .to(".text-container-top h2", { opacity: 1, y: 0, stagger: 0.1 }, "<+=0.2")
  .to(".text-container-bottom h2", { opacity: 1, y: 0, stagger: 0.1 }, "<+=0.3")
  .to(".marquee-div", { opacity: 1, y: 0 }, "<+=0.5")
  .to(".lets-talk-button", { opacity: 1, y: 0 }, "<"); // Shows up together with marquee

  const carouselSection = document.querySelector(".carousel-section");
  const carouselSlide = carouselSection.querySelector(".swiper-wrapper");
  const fixedTop = document.querySelector(".text-container-top");
  const fixedBottom = document.querySelector(".text-container-bottom");
  const normalTop = document.querySelector(".text-container-top-normal");
  const normalBottom = document.querySelector(".text-container-bottom-normal");
  const isMobile = window.innerWidth <= 768;
  const isSmallScreen = window.innerWidth < 1920;
  
  if (!fixedTop || !fixedBottom || !normalTop || !normalBottom) {
    console.warn("Some elements are missing. Exiting early.");
    return;
  }
  
  const fixedTopRect = fixedTop.getBoundingClientRect();
  const fixedBottomRect = fixedBottom.getBoundingClientRect();
  const normalTopRect = normalTop.getBoundingClientRect();
  const normalBottomRect = normalBottom.getBoundingClientRect();
  const offset = isMobile ? fixedTop.offsetHeight * 0.35 : (isSmallScreen ? fixedTop.offsetHeight * 0.7 : fixedTop.offsetHeight * 0.82);
  
  const deltaYTop = normalTopRect.top - fixedTopRect.top + offset;
  const deltaYBottom = normalBottomRect.top - fixedBottomRect.top - offset;

  ScrollTrigger.create({
    id: "snapTimeline",
    trigger: ".swiper-container",
    start: "top bottom",
    end: isMobile ? "top 45%" : "top 20%",
    scrub: isMobile ? false : 1,
    markers: false,
    onEnter: () => {
      if (!window.isScrolling) {
        // window.isScrolling = true;
        // gsap.to(window, {
        //   duration: 1,
        //   scrollTo: {
        //     y: carouselSection,
        //     offsetY: 0,
        //   },
        //   ease: "power3.out",
        //   onComplete: () => {
        //     window.isScrolling = false;
        //   },
        // });
        // lenis.scrollTo(carouselSection, {
        //   duration: 1,
        //   easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // power3.out-like
        //   onComplete: () => {
        //     window.isScrolling = false;
        //   }
        // });
      }
    },
    onEnterBack: () => {
      if (!window.isScrolling) {
        // window.isScrolling = true;
        // setTimeout(() => {
        //   gsap.to(window, {
        //     duration: 0.8,
        //     scrollTo: { y: 0, autoKill: false },
        //     ease: "power2.out",
        //     onComplete: () => {
        //       window.isScrolling = false;
        //     },
        //   });
        // }, 50);
        // setTimeout(() => {
        //   lenis.scrollTo(0, {
        //     duration: 0.8,
        //     easing: t => 1 - Math.pow(1 - t, 2), // power2.out
        //     onComplete: () => {
        //       window.isScrolling = false;
        //     }
        //   });
        // }, 50);        
      }
    },
    onUpdate: (self) => {
      const progress = self.progress;

      const animatedTopY = gsap.utils.interpolate(0, deltaYTop, progress);
      const animatedBottomY = gsap.utils.interpolate(0, deltaYBottom, progress);

      gsap.to(fixedTop, {
        y: animatedTopY,
        duration: 0.3,
        ease: "power2.out",
        overwrite: true
      });

      gsap.to(fixedBottom, {
        y: animatedBottomY,
        duration: 0.3,
        ease: "power2.out",
        overwrite: true
      });

      const SHOW_THRESHOLD = 0.99;
      const HIDE_THRESHOLD = 0.98;
      if (progress >= SHOW_THRESHOLD) {
        fixedTop.style.opacity = 1;
        fixedBottom.style.opacity = 1; // 0
        normalTop.style.opacity = 0;
        normalBottom.style.opacity = 0;
      } else if (progress <= HIDE_THRESHOLD) {
        fixedTop.style.opacity = 1;
        fixedBottom.style.opacity = 1;
        normalTop.style.opacity = 0; //0
        normalBottom.style.opacity = 0;
      }

      fixedTop.style.zIndex = progress > 0.35 ? "10" : "30";
      fixedBottom.style.zIndex = progress > 0.10 ? "30" : "10";
    },
  });

  let resizeTimeoutReload;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeoutReload);

    resizeTimeoutReload = setTimeout(() => {
      const isDesktop = window.innerWidth > 768;

      if (isDesktop) {
        window.location.reload();
      }
    }, 200);
  });



  // Add scroll snap from carousel to showcase section
  // ScrollTrigger.create({
  //   trigger: showcaseSection,
  //   start: "top bottom",
  //   end: "top top",
  //   onEnter: () => {
  //     if (!isMobile) {
  //       // Fade out text when entering showcase section
  //       gsap.to([textTop, textBottom], {
  //         opacity: 0,
  //         duration: 0.3,
  //       });

  //       if (!window.isScrolling) {
  //         window.isScrolling = true;
  //         gsap.to(window, {
  //           duration: 0.8,
  //           scrollTo: {
  //             y: showcaseSection,
  //             offsetY: 0,
  //           },
  //           ease: "power2.out",
  //           onComplete: () => {
  //             window.isScrolling = false;
  //           },
  //         });
  //       }
  //     }
  //   },
  //   onEnterBack: () => {
  //     if (!isMobile) {
  //       // Fade in text when returning to carousel section
  //       gsap.to([textTop, textBottom], {
  //         opacity: 1,
  //         duration: 0.3,
  //       });

  //       if (!window.isScrolling) {
  //         window.isScrolling = true;
  //         setTimeout(() => {
  //           gsap.to(window, {
  //             duration: 0.8,
  //             scrollTo: {
  //               y: carouselSection,
  //               offsetY: 0,
  //             },
  //             ease: "power2.out",
  //             onComplete: () => {
  //               window.isScrolling = false;
  //             },
  //           });
  //         }, 50);
  //       }
  //     }
  //   },
  // });  
});